import { Link } from 'react-router-dom';

export default function CTA() {
  return (
    <section className="relative py-16 md:py-24 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20modern%20office%20meeting%20space%20with%20large%20windows%20and%20natural%20light%20streaming%20in%2C%20elegant%20minimalist%20interior%20design%2C%20soft%20warm%20cream%20and%20gold%20tones%2C%20sophisticated%20professional%20atmosphere%2C%20clean%20architectural%20composition%20with%20inviting%20collaborative%20workspace&width=1800&height=800&seq=cta-bg-home&orientation=landscape"
          alt="17.c 起草官网 联系我们"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/60 to-black/40" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white font-heading mb-4">
          准备好开始了吗？
        </h2>
        <p className="text-sm md:text-base text-white/80 max-w-xl mx-auto mb-8">
          无论是文件起草还是官网建设，我们都能为您提供专业的一站式解决方案。立即联系我们，获取专属服务方案。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/about"
            className="px-8 py-3.5 rounded-lg bg-primary-500 text-background-50 text-base font-medium hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            免费咨询
          </Link>
          <Link
            to="/category/wenjian-qicao"
            className="px-8 py-3.5 rounded-lg border border-white/30 text-white text-base font-medium hover:bg-white/10 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            浏览服务
          </Link>
        </div>
      </div>
    </section>
  );
}